import { AgentActivityWebService } from '@linktivity/gds-neo';
import config from '../config';

const agentActivityApi = new AgentActivityWebService.ActivityApi(config);

export default agentActivityApi;
